// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Cart item name/badge column ─────────────────────────── */
.cartItemNameBadgeCol {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.cartItemNameBadgeRow {
  display: flex;
  flex-direction: column;
  gap: 5px;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
}

/* Inline badges */
.cartItemBadge {
  font-size: 10px;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 999px;
  white-space: nowrap;
  flex-shrink: 0;
}

.cartItemBadge--combo {
  color: #6d28d9;
  background: #ede9fe;
  border: 1px solid #c4b5fd;
}

.cartItemBadge--complimentary {
  color: #059669;
  background: #d1fae5;
  border: 1px solid #6ee7b7;
  width: max-content;
}

/* Variant sub-line */
.cartItemVariantLine {
  font-size: 11px;
  color: #6b7280;
  margin: 0;
  padding: 0;
  line-height: 1.4;
  text-align: start;
  max-width: 100%;
  font-weight: 600;
  word-break: break-all;
}

/* Add-on products sub-line */
.cartItemAddonLine {
  font-size: 11px;
  color: #717680;
  margin: 0;
  padding: 0;
  line-height: 1.4;
  text-align: start;
  max-width: 100%;
  word-break: break-all;
}

/* Inline note */
.cartItemNoteInline {
  font-size: 11px;
  color: #d97706;
  font-weight: 500;
  margin: 0;
  line-height: 1.4;
  text-align: start;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Edit > link */
.cartItemEditLink {
  background: none;
  border: none;
  padding: 0;
  font-size: 11px;
  font-weight: 600;
  color: #2563eb;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  line-height: 1.4;
}

.cartItemEditLink:hover {
  text-decoration: underline;
}

.combo-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 6px;
  font-size: 11px;
  font-weight: 600;
  color: #7c3aed;
  background-color: #ede9fe;
  border: 1px solid #c4b5fd;
  border-radius: 4px;
  white-space: nowrap;
  flex-shrink: 0;
}

#myDiv3 {
  background-color: #fff !important;
  border: 0px;
  border-radius: 4px;
  width: 100% !important;
}

.dark #myDiv3 {
  background-color: #353a50 !important;
  color: #fff !important;
}

.cartElementName {
  display: flex;
  gap: 1rem;
}

#myDiv3:focus {
  outline: none !important;
  background-color: #b9c4f3 !important;
  color: #353a50 !important;
}

.light .form-edit-wrapper {
  background-color: #fff;
}

#myFocusDiv {
  background-color: #fff;
  width: 100%;
  border: 0;
  border-radius: 4px;
}

/* Redesigning cart */

.cartItemNameRow {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
}

.cartItemIconName {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

.cartItemIconName > div:first-child {
  flex-shrink: 0;
  margin-top: 2px;
}

.cartProductDetailsContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cartProductName {
  font-size: 0.813rem;
  font-weight: 600;
  color: #0b0b0b;
  text-transform: capitalize;
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.deleteCartButton {
  background: transparent;
  height: 32px;
  width: 32px;
  color: var(--surface-g5);
  cursor: pointer;
  border: none;
}

.quantityAndPrice {
  margin-top: 5px;
}

.increaseDecreseButtonContainer {
  display: flex;
  padding: 4px 10px;
  border: 1.5px solid #e2e8f0;
  border-radius: 16px;
  gap: 5px;
  align-items: center;
  height: 100%;
  flex-shrink: 0;
}

.decreaseItemQuantity {
  border: 0;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 15px;
  padding: 0;
  cursor: pointer;
  color: #62748e;
}

.increaseItemQuantity {
  border: 0;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 15px;
  padding: 0;
  cursor: pointer;
  color: #62748e;
}

.cartFormInput {
  border: 0;
  background: transparent;
  /* max-width: 22px; */
  min-width: 4ch;
  text-align: center;
  font-size: 0.813rem;
  font-weight: 700;
  color: #8d8787;
}

/* Till here */

.cart-quantity-offer-box {
  display: flex;
  justify-content: space-between;
  width: 90%;
  gap: 5px;
}

.offer-increaseDecreseItemQuantityContainer {
  pointer-events: none;
  opacity: 0.7;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  width: fit-content;
  background-color: #fff;
  border: none;
}

.light .offer-increaseDecreseItemQuantityContainer {
  pointer-events: none;
  opacity: 0.7;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  width: fit-content;
  background-color: #fff;
  border: none;
}

.light .increaseDecreseItemQuantityContainer {
  background-color: #fff;
}
.dark .offer-increaseDecreseItemQuantityContainer {
  pointer-events: none;
  opacity: 0.7;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  width: fit-content;
  background-color: #353a50;
  border: none;
}

.offer-increaseDecreseItemQuantityContainer:hover {
  cursor: not-allowed !important;
}

.offer-details-hide {
  display: none;
}

.offer-details-hide {
  display: block;
}

.sp-input {
  width: 3rem;
}

/*** New Cart redesing **/

.cartProductName {
  display: flex;
  align-items: center;
  gap: 6px;
}

.addOnModalDisplayContainer {
  display: flex;
  flex: 1 0 0;
  color: var(--Gray-500, #717680);

  /* Text xs/Regular */
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.addOnModalDisplayContainer p {
  width: 87%;
  text-align: start;
  margin: 0;
  padding: 0;
  display: inline;
  /* white-space: nowrap; */
  text-align: left;
}

.outOfStockText {
  font-weight: 700;
  color: var(--red-solid);
}

.priceAndTrashIcon {
  display: flex;
  align-items: start;
  gap: 0.5rem;
}

.cartProductDetailsUpperContainer {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.cartProductDetailsUpperContainerButton {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-top: 4px;
}

.recallQuantityText {
  color: var(--red-solid);
}

.cartProductTitle {
  text-align: left;
  font-weight: 500;
  line-height: 1.3;
  margin: 0;
  padding: 0;
  max-width: 100%;
  flex: 0 1 auto;
  min-width: 0;
  word-break: break-all;
}

.complementaryCartStatus {
  display: flex;
  align-items: center;
  gap: 4px;
  background-color: #edf8ff;
  padding: 4px 6px;
  color: #0860e6;
  width: max-content;
  font-size: 13px;
  font-weight: 700;
  border-radius: 12px;
  margin-top: 8px;
}
/***********************/

/* Cart item highlight animation */
@keyframes cartItemHighlightAnimation {
  0% {
    background-color: var(--Blue-B4, #d9f2ff);
    transform: scale(1);
  }
  50% {
    background-color: #b3e0ff;
    transform: scale(1.02);
  }
  100% {
    background-color: var(--Blue-B4, #d9f2ff);
    transform: scale(1);
  }
}

.cartItemHighlight,
#myDiv3.cartItemHighlight,
#myFocusDiv.cartItemHighlight {
  animation: cartItemHighlightAnimation 0.5s ease-in-out 2;
  background-color: var(--Blue-B4, #d9f2ff) !important;
  border-radius: 4px;
}

.dark .cartItemHighlight,
.dark #myDiv3.cartItemHighlight,
.dark #myFocusDiv.cartItemHighlight {
  animation: cartItemHighlightAnimationDark 0.5s ease-in-out 2;
  background-color: rgba(8, 96, 230, 0.3) !important;
}

@keyframes cartItemHighlightAnimationDark {
  0% {
    background-color: rgba(8, 96, 230, 0.3);
    transform: scale(1);
  }
  50% {
    background-color: rgba(8, 96, 230, 0.4);
    transform: scale(1.02);
  }
  100% {
    background-color: rgba(8, 96, 230, 0.3);
    transform: scale(1);
  }
}

.cart-item-keyboard-focused,
#myDiv3.cart-item-keyboard-focused,
#myFocusDiv.cart-item-keyboard-focused {
  outline: 2px solid #3b82f6 !important;
  outline-offset: -2px;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2) !important;
  border-radius: 4px;
}

.cartMainContainer {
  cursor: pointer;
  transition: background 0.2s;
  overflow: hidden;
  width: 100%;
}

.cartMainContainer:hover {
  background-color: rgba(0, 0, 0, 0.02);
}

/* Style for the comment text in the list */
.product-comment-preview {
  font-size: 11px;
  color: #ef4444; /* red color to grab attention */
  margin-top: 4px;
}
.removedByKitchenItem {
  text-decoration: line-through;
  text-decoration-color: #dc2626;
  text-decoration-thickness: 1px;
}

.removedByKitchenStatus {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #dc2626;
  font-size: 0.813rem;
  font-weight: 500;
  margin-top: 8px;
}

.cartProductsUpperTitle {
  display: flex;
  gap: 4px;
}

.cartItemNameRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  width: 100%;
  min-width: 0;
  overflow: hidden;
}

.cartItemIconName {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.cartItemControlsRow {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  width: 100%;
  margin-top: 4px;
}

.cartItemAddonsText {
  font-size: 12px;
  color: #717680;
  margin: 4px 0 0 20px;
  text-align: left;
  line-height: 1.4;
}

.cartItemNoteText {
  font-size: 11px;
  color: #ef4444;
  margin: 2px 0 0 20px;
  text-align: left;
  font-weight: 500;
}

.cartItemNoteBox {
  display: flex;
  align-items: center;
  gap: 5px;
  border-left: 3px solid #93c5fd;
  background-color: #eff6ff;
  padding: 3px 8px;
  border-radius: 0 4px 4px 0;
  margin-top: 5px;
}

.cartItemNoteIcon {
  width: 13px;
  height: 13px;
  color: #3b82f6;
  flex-shrink: 0;
}

.cartItemNoteBoxText {
  font-size: 11px;
  color: #374151;
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/CartItem/CartItem.css"],"names":[],"mappings":"AAAA,+DAA+D;AAC/D;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,SAAS;EACT,kBAAkB;AACpB;;AAEA,qBAAqB;;AAErB;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,OAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,wBAAwB;EACxB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,cAAc;;AAEd;EACE,aAAa;EACb,8BAA8B;EAC9B,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA,yBAAyB;;AAEzB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,WAAW;EACX,+BAA+B;;EAE/B,oBAAoB;EACpB,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,eAAe;EACf,cAAc;EACd,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA,wBAAwB;;AAExB,kCAAkC;AAClC;EACE;IACE,yCAAyC;IACzC,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;EACA;IACE,yCAAyC;IACzC,mBAAmB;EACrB;AACF;;AAEA;;;EAGE,wDAAwD;EACxD,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA;;;EAGE,4DAA4D;EAC5D,kDAAkD;AACpD;;AAEA;EACE;IACE,uCAAuC;IACvC,mBAAmB;EACrB;EACA;IACE,uCAAuC;IACvC,sBAAsB;EACxB;EACA;IACE,uCAAuC;IACvC,mBAAmB;EACrB;AACF;;AAEA;;;EAGE,qCAAqC;EACrC,oBAAoB;EACpB,wDAAwD;EACxD,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qCAAqC;AACvC;;AAEA,2CAA2C;AAC3C;EACE,eAAe;EACf,cAAc,EAAE,gCAAgC;EAChD,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["/* ── Cart item name/badge column ─────────────────────────── */\n.cartItemNameBadgeCol {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.cartItemNameBadgeRow {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  max-width: 100%;\n  min-width: 0;\n  overflow: hidden;\n}\n\n/* Inline badges */\n.cartItemBadge {\n  font-size: 10px;\n  font-weight: 700;\n  padding: 2px 7px;\n  border-radius: 999px;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.cartItemBadge--combo {\n  color: #6d28d9;\n  background: #ede9fe;\n  border: 1px solid #c4b5fd;\n}\n\n.cartItemBadge--complimentary {\n  color: #059669;\n  background: #d1fae5;\n  border: 1px solid #6ee7b7;\n  width: max-content;\n}\n\n/* Variant sub-line */\n.cartItemVariantLine {\n  font-size: 11px;\n  color: #6b7280;\n  margin: 0;\n  padding: 0;\n  line-height: 1.4;\n  text-align: start;\n  max-width: 100%;\n  font-weight: 600;\n  word-break: break-all;\n}\n\n/* Add-on products sub-line */\n.cartItemAddonLine {\n  font-size: 11px;\n  color: #717680;\n  margin: 0;\n  padding: 0;\n  line-height: 1.4;\n  text-align: start;\n  max-width: 100%;\n  word-break: break-all;\n}\n\n/* Inline note */\n.cartItemNoteInline {\n  font-size: 11px;\n  color: #d97706;\n  font-weight: 500;\n  margin: 0;\n  line-height: 1.4;\n  text-align: start;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Edit > link */\n.cartItemEditLink {\n  background: none;\n  border: none;\n  padding: 0;\n  font-size: 11px;\n  font-weight: 600;\n  color: #2563eb;\n  cursor: pointer;\n  text-align: left;\n  font-family: inherit;\n  line-height: 1.4;\n}\n\n.cartItemEditLink:hover {\n  text-decoration: underline;\n}\n\n.combo-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  padding: 2px 6px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #7c3aed;\n  background-color: #ede9fe;\n  border: 1px solid #c4b5fd;\n  border-radius: 4px;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n#myDiv3 {\n  background-color: #fff !important;\n  border: 0px;\n  border-radius: 4px;\n  width: 100% !important;\n}\n\n.dark #myDiv3 {\n  background-color: #353a50 !important;\n  color: #fff !important;\n}\n\n.cartElementName {\n  display: flex;\n  gap: 1rem;\n}\n\n#myDiv3:focus {\n  outline: none !important;\n  background-color: #b9c4f3 !important;\n  color: #353a50 !important;\n}\n\n.light .form-edit-wrapper {\n  background-color: #fff;\n}\n\n#myFocusDiv {\n  background-color: #fff;\n  width: 100%;\n  border: 0;\n  border-radius: 4px;\n}\n\n/* Redesigning cart */\n\n.cartItemNameRow {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n  width: 100%;\n}\n\n.cartItemIconName {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  flex: 1;\n  min-width: 0;\n}\n\n.cartItemIconName > div:first-child {\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.cartProductDetailsContainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.cartProductName {\n  font-size: 0.813rem;\n  font-weight: 600;\n  color: #0b0b0b;\n  text-transform: capitalize;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n}\n\n.deleteCartButton {\n  background: transparent;\n  height: 32px;\n  width: 32px;\n  color: var(--surface-g5);\n  cursor: pointer;\n  border: none;\n}\n\n.quantityAndPrice {\n  margin-top: 5px;\n}\n\n.increaseDecreseButtonContainer {\n  display: flex;\n  padding: 4px 10px;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 16px;\n  gap: 5px;\n  align-items: center;\n  height: 100%;\n  flex-shrink: 0;\n}\n\n.decreaseItemQuantity {\n  border: 0;\n  background-color: transparent;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 15px;\n  padding: 0;\n  cursor: pointer;\n  color: #62748e;\n}\n\n.increaseItemQuantity {\n  border: 0;\n  background-color: transparent;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 15px;\n  padding: 0;\n  cursor: pointer;\n  color: #62748e;\n}\n\n.cartFormInput {\n  border: 0;\n  background: transparent;\n  /* max-width: 22px; */\n  min-width: 4ch;\n  text-align: center;\n  font-size: 0.813rem;\n  font-weight: 700;\n  color: #8d8787;\n}\n\n/* Till here */\n\n.cart-quantity-offer-box {\n  display: flex;\n  justify-content: space-between;\n  width: 90%;\n  gap: 5px;\n}\n\n.offer-increaseDecreseItemQuantityContainer {\n  pointer-events: none;\n  opacity: 0.7;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n  width: fit-content;\n  background-color: #fff;\n  border: none;\n}\n\n.light .offer-increaseDecreseItemQuantityContainer {\n  pointer-events: none;\n  opacity: 0.7;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n  width: fit-content;\n  background-color: #fff;\n  border: none;\n}\n\n.light .increaseDecreseItemQuantityContainer {\n  background-color: #fff;\n}\n.dark .offer-increaseDecreseItemQuantityContainer {\n  pointer-events: none;\n  opacity: 0.7;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n  width: fit-content;\n  background-color: #353a50;\n  border: none;\n}\n\n.offer-increaseDecreseItemQuantityContainer:hover {\n  cursor: not-allowed !important;\n}\n\n.offer-details-hide {\n  display: none;\n}\n\n.offer-details-hide {\n  display: block;\n}\n\n.sp-input {\n  width: 3rem;\n}\n\n/*** New Cart redesing **/\n\n.cartProductName {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.addOnModalDisplayContainer {\n  display: flex;\n  flex: 1 0 0;\n  color: var(--Gray-500, #717680);\n\n  /* Text xs/Regular */\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.addOnModalDisplayContainer p {\n  width: 87%;\n  text-align: start;\n  margin: 0;\n  padding: 0;\n  display: inline;\n  /* white-space: nowrap; */\n  text-align: left;\n}\n\n.outOfStockText {\n  font-weight: 700;\n  color: var(--red-solid);\n}\n\n.priceAndTrashIcon {\n  display: flex;\n  align-items: start;\n  gap: 0.5rem;\n}\n\n.cartProductDetailsUpperContainer {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.cartProductDetailsUpperContainerButton {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  margin-top: 4px;\n}\n\n.recallQuantityText {\n  color: var(--red-solid);\n}\n\n.cartProductTitle {\n  text-align: left;\n  font-weight: 500;\n  line-height: 1.3;\n  margin: 0;\n  padding: 0;\n  max-width: 100%;\n  flex: 0 1 auto;\n  min-width: 0;\n  word-break: break-all;\n}\n\n.complementaryCartStatus {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background-color: #edf8ff;\n  padding: 4px 6px;\n  color: #0860e6;\n  width: max-content;\n  font-size: 13px;\n  font-weight: 700;\n  border-radius: 12px;\n  margin-top: 8px;\n}\n/***********************/\n\n/* Cart item highlight animation */\n@keyframes cartItemHighlightAnimation {\n  0% {\n    background-color: var(--Blue-B4, #d9f2ff);\n    transform: scale(1);\n  }\n  50% {\n    background-color: #b3e0ff;\n    transform: scale(1.02);\n  }\n  100% {\n    background-color: var(--Blue-B4, #d9f2ff);\n    transform: scale(1);\n  }\n}\n\n.cartItemHighlight,\n#myDiv3.cartItemHighlight,\n#myFocusDiv.cartItemHighlight {\n  animation: cartItemHighlightAnimation 0.5s ease-in-out 2;\n  background-color: var(--Blue-B4, #d9f2ff) !important;\n  border-radius: 4px;\n}\n\n.dark .cartItemHighlight,\n.dark #myDiv3.cartItemHighlight,\n.dark #myFocusDiv.cartItemHighlight {\n  animation: cartItemHighlightAnimationDark 0.5s ease-in-out 2;\n  background-color: rgba(8, 96, 230, 0.3) !important;\n}\n\n@keyframes cartItemHighlightAnimationDark {\n  0% {\n    background-color: rgba(8, 96, 230, 0.3);\n    transform: scale(1);\n  }\n  50% {\n    background-color: rgba(8, 96, 230, 0.4);\n    transform: scale(1.02);\n  }\n  100% {\n    background-color: rgba(8, 96, 230, 0.3);\n    transform: scale(1);\n  }\n}\n\n.cart-item-keyboard-focused,\n#myDiv3.cart-item-keyboard-focused,\n#myFocusDiv.cart-item-keyboard-focused {\n  outline: 2px solid #3b82f6 !important;\n  outline-offset: -2px;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2) !important;\n  border-radius: 4px;\n}\n\n.cartMainContainer {\n  cursor: pointer;\n  transition: background 0.2s;\n  overflow: hidden;\n  width: 100%;\n}\n\n.cartMainContainer:hover {\n  background-color: rgba(0, 0, 0, 0.02);\n}\n\n/* Style for the comment text in the list */\n.product-comment-preview {\n  font-size: 11px;\n  color: #ef4444; /* red color to grab attention */\n  margin-top: 4px;\n}\n.removedByKitchenItem {\n  text-decoration: line-through;\n  text-decoration-color: #dc2626;\n  text-decoration-thickness: 1px;\n}\n\n.removedByKitchenStatus {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  color: #dc2626;\n  font-size: 0.813rem;\n  font-weight: 500;\n  margin-top: 8px;\n}\n\n.cartProductsUpperTitle {\n  display: flex;\n  gap: 4px;\n}\n\n.cartItemNameRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 6px;\n  width: 100%;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.cartItemIconName {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.cartItemControlsRow {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  margin-top: 4px;\n}\n\n.cartItemAddonsText {\n  font-size: 12px;\n  color: #717680;\n  margin: 4px 0 0 20px;\n  text-align: left;\n  line-height: 1.4;\n}\n\n.cartItemNoteText {\n  font-size: 11px;\n  color: #ef4444;\n  margin: 2px 0 0 20px;\n  text-align: left;\n  font-weight: 500;\n}\n\n.cartItemNoteBox {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  border-left: 3px solid #93c5fd;\n  background-color: #eff6ff;\n  padding: 3px 8px;\n  border-radius: 0 4px 4px 0;\n  margin-top: 5px;\n}\n\n.cartItemNoteIcon {\n  width: 13px;\n  height: 13px;\n  color: #3b82f6;\n  flex-shrink: 0;\n}\n\n.cartItemNoteBoxText {\n  font-size: 11px;\n  color: #374151;\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
